import type { Maybe } from '@adornis/base/utilTypes.js';
import { showDialog } from '@adornis/dialog/dialog-functions.js';
import { TextInput } from '@adornis/formfield/fields/text-input.js';
import { stateful, useState } from '@adornis/functional-lit/stateful.js';
import { html } from 'lit';
import { DialogHeader } from '@adornis/components/client/DialogHeader.js';

interface PromptStringFieldDialogOptions {
  title: string;
  placeholder: string;
  description?: string;
}

const PromptStringFieldDialog = stateful(
  (props: {
    value: Maybe<string>;
    options: PromptStringFieldDialogOptions;
    resolve: (value: { value: string }) => void;
    reject: () => void;
  }) => {
    const [value, setValue] = useState(props.value);

    return html`
      <div class="dialog-container">
        ${DialogHeader({
          title: props.options.title,
          close: props.reject,
          closeLabel: 'Dialog schließen',
        })}
        ${props.options.description ? html`<p>${props.options.description}</p>` : html``}
        <div class="flex flex-col gap-2">
          <span class="text-sm font-semibold text-base-content/70">${props.options.placeholder}</span>
          ${TextInput({ value, onPicked: value => setValue(value) })}
        </div>

        <button
          class="btn btn-primary"
          @click=${() =>
            props.resolve({
              value: value ?? '',
            })}
        >
          Annehmen
        </button>
      </div>
    `;
  },
);

export async function openPromptStringFieldDialog(value: Maybe<string>, options: PromptStringFieldDialogOptions) {
  return showDialog<{ value: string }>({
    content: (resolve, reject) => PromptStringFieldDialog({ value, options, resolve, reject }),
  });
}
